import { CompanyInitValue } from 'store/company/company.constants'
import { Order, OrdersInitialState } from './orders.types'

export const orderMock: Order = {
  accountPayableEmail: '',
  baseRate: 0,
  billingEmail: '',
  currency: 'CAD',
  companyId: '',
  customerId: '',
  customerName: '',
  detentionCharges: 0,
  fuelSurcharge: 0,
  layoverCharges: 0,
  loadNumber: '',
  notes: '',
  notificationEmail: '',
  orderEvents: [],
  orderId: 0,
  otherCharges: 0,
  status: 'NEW',
  userOrderId: '',
}

export const initialState: OrdersInitialState = {
  newOrders: [],
  activerOrders: [],
  archivedOrders: [],
  deliveryToDrop: [],
  selectedOrder: orderMock,
  selectedOrderTab: 'NEW',
  selectedCompany: CompanyInitValue,
  isSelectedOrderLoading: false,
}
